module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBoldItalic.d41c0a34.ttf";